import React from 'react';
import LeftPaneView from './LeftPaneView'
import RightPanel from './RightPanel'

export default ({
    scaleMode, livefeedSlides, slideCurrentIndex, nodeMap, stepNumberState, editorView,
    sensorMap, mapConfigMode, dispatch, handleOpenLocationModal, focusMapApiInput }) => {
    //scaleMode: for "Choose Template layout" feature, a snapshot/ scale version of livefeed will be rendered
    return (
        <div className={`livefeed-preview-wrapper${scaleMode ? '-scaleMode' : ''}`}>
            <div className="livefeed-preview"  >
                <LeftPaneView
                    scaleMode={scaleMode}
                    dispatch={dispatch}
                    livefeedSlides={livefeedSlides}
                    slideCurrentIndex={slideCurrentIndex}
                    nodeMap={nodeMap}
                    stepNumberState={stepNumberState}
                    editorView={editorView}
                    sensorMap={sensorMap}
                    mapConfigMode={mapConfigMode}
                    focusMapApiInput={focusMapApiInput}
                    handleOpenLocationModal={handleOpenLocationModal} />
                <RightPanel
                    scaleMode={scaleMode}
                    dispatch={dispatch}
                    livefeedSlide={livefeedSlides[slideCurrentIndex]}
                    editorView={editorView}
                    stepNumberState={stepNumberState}
                    nodeMap={nodeMap}
                    sensorMap={sensorMap}
                    handleOpenLocationModal={handleOpenLocationModal}
                />
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/index.jsx